<template>
    <v-container>
        <v-btn x-small :color="estimateStatusColor" dark class="ml-n3 pa-1" @click="showDialog">
            {{ localEstimateStatus }}
        </v-btn>
        <v-row justify="center">
            <v-dialog
                    persistent
                    v-model="dialog"
                    max-width="290"
                    @keydown.esc="dialog = false"
                    @keydown.enter="toggleEstimateStatus"
                    @keydown.space="toggleEstimateStatus"
            >
                <v-card>
                    <v-card-title class="headline">진행 상태 변경</v-card-title>
                    <v-card-text>
                        상태를 변경하시겠습니까?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="green darken-1"
                                text
                                @click="dialog = false"
                        >취소</v-btn>

                        <v-btn
                                color="green darken-1"
                                text
                                @click="toggleEstimateStatus"
                        >변경</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios";

export default {
    name: 'EstimateStatusButton',
    props: {
        orderId: {},
        estimateStatus: {},
        disable: {}
    },
    data() {
        return {
            localEstimateStatus: this.estimateStatus,
            estimateStatusColor: 'primary',
            dialog: false
        }
    },
    methods: {
        showDialog(event) {
            if(this.disable == true){
                return false
            }
            event.preventDefault()
            this.dialog = true
        },
        toggleEstimateStatus(event) {

            if(this.disable == true){
                return false
            }

            event.preventDefault()
            this.dialog = false

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/toggleEstimateStatus/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data && response.data.orderStatus != ''){

                    this.localEstimateStatus = response.data.estimateStatus
                    this.changeButtonColor()

                }

            })

        },
        changeButtonColor() {

            switch(this.localEstimateStatus){

                case '견적중':
                    this.estimateStatusColor = '#B495FF'
                    break

                case '입금대기중':
                    this.estimateStatusColor = '#FF3E79'
                    break

                case '샘플제작중':
                    this.estimateStatusColor = '#785EFF'
                    break

                case '디자인중':
                    this.estimateStatusColor = '#36A4FF'
                    break

                default:
                    this.estimateStatusColor = '#B495FF'
                    break

            }

        }
    },
    created(){
        this.changeButtonColor()
    }
}
</script>